import { render, staticRenderFns } from "./CartPayed.vue?vue&type=template&id=7c8da7a7"
import script from "./CartPayed.vue?vue&type=script&lang=js"
export * from "./CartPayed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports